import { toast } from 'sonner';

// Surfaces API/action failures as a visible toast instead of a silent no-op.
// Use in catch blocks for user-initiated actions (send/save/submit/delete).
export const notifyError = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  const msg = (typeof detail === 'string' && detail) || error?.message || fallback;
  toast.error(typeof msg === 'string' ? msg : fallback);
};

export const notifySuccess = (message) => toast.success(message);
